import React from 'react';
import Box from "@mui/material/Box";
import { DataGrid } from '@mui/x-data-grid';
import {getDiscountStatusName} from "../../enum/discountStatus";


export const DiscountTraceTable = ({traces}) => {

    const columns = [
        {
            field: 'box',
            flex: 100,
            headerName: 'Box',
            valueGetter: (params) => params.row.discount.box || '',
        },        {
            field: 'discount',
            flex: 100,
            headerName: 'Discount',
            valueGetter: (params) => params.row.discount.hash || '',
        },
        {
            field: 'discountAmount',
            flex: 50,
            headerName: 'Discount %',
            valueGetter: (params) => params.row.discountCondition.amount + '%',
        },
        {
            field: 'patientCategory',
            flex: 50,
            headerName: 'Patient Category',
            valueGetter: (params) => params.row.discountCondition.patient_type.name,
        },
        {
            field: 'country',
            flex: 50,
            headerName: 'Country',
            valueGetter: (params) => params.row.discountCondition.country.name,
        },
        {
            field: 'action',
            flex: 50,
            headerName: 'Action',
            description: 'This column has a value getter and is not sortable.',
            valueGetter: (params) => getDiscountStatusName(params.row.status),
        },
        {
            field: 'triggeredBy',
            flex: 100,
            headerName: 'Triggered by',
            valueGetter: (params) => params.row.customer.wallet,
        },
        {
            field: 'triggeredByRole',
            flex: 50,
            headerName: 'Role',
            valueGetter: (params) => params.row.customer.role,
        },
        {
            field: 'block',
            flex: 100,
            headerName: 'Block',
            valueGetter: (params) => params.row.transaction,
        },
        {
            field: 'created',
            flex: 100,
            headerName: 'Created',
            type: 'dateTime',
            valueGetter: (params) => new Date(params.row.created),
        },
    ];

    return <Box sx={{width: '100%'}}>
        <DataGrid
            autoHeight
            rowHeight={38}
            rows={traces}
            columns={columns}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 100,
                    },
                },
            }}
            pageSizeOptions={[25, 50, 100]}
            checkboxSelection={false}
            disableRowSelectionOnClick
        />
    </Box>
}
